exports.wrapPageElement = ({ element }) => element
